import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { IframeComponent } from '@heda/core-hospital-ui/components/iframe/iframe.component';
import { mergeMap } from 'rxjs/operators';

@Component({
  selector: 'hw-cda-preview',
  template: `
    <hw-spinner [loading]="loading"></hw-spinner>
    <hw-iframe #preview (closed)="onClose($event)"></hw-iframe>
  `
})
export class CdaPreviewComponent implements OnInit {
  @Output() public closed = new EventEmitter();

  @ViewChild('preview') public previewIframe: IframeComponent;
  @Input() public params: { id: any; type: string };
  public loading: boolean;

  constructor(private clinicalDocumentService: ClinicalDocumentService) {}

  public ngOnInit(): void {
    this.loading = true;
    this.clinicalDocumentService
      .getCdaPreviewMeta(this.params)
      .pipe(mergeMap((meta) => this.clinicalDocumentService.getCachePreviewUrl(meta.documentKey)))
      .subscribe({
        next: (url) => {
          this.previewIframe.open(url);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.onClose(true);
        }
      });
  }

  public onClose(closed: boolean): void {
    if (closed) {
      this.closed.emit(true);
    }
  }
}
